import BaseText from "app/components/Text";
import styled from "styled-components";

export const Text = styled(BaseText)`
  font-size: 14px;
  font-height: 15px;
  color: #050e0e;
`;
